import HTTP from "@/_helpers/http";
import { CRYPTO__API } from "@/_helpers/urls";
import { CRYPTO__MUTATIONS } from "../mutation-types";
import { CRYPTO__ACTIONS } from "../action-types";
import toast from "@/services/Notification";
import router from "@/router";

// State
const state = {
  cryptoaddresses: [],
  cryptodetails: {},
  networks: [],
  code: null,
  ovypaycrypto: [],       // must be [] so v-for doesn't break
  ovypayClientUrl: '',    // populated from general_informations.client_portal_url via API
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [CRYPTO__MUTATIONS.GETALL](state, data) {
    state.cryptoaddresses = data;
  },
  [CRYPTO__MUTATIONS.NETWORKS](state, data) {
    state.networks = data;
  },
  [CRYPTO__MUTATIONS.DETAILS](state, data) {
    state.cryptodetails = data;
  },
  [CRYPTO__MUTATIONS.CODE](state, code) {
    state.code = code;
  },

  // API returns { networks: [...], client_portal_url: "..." }
  // Extract only the networks array into ovypaycrypto
  [CRYPTO__MUTATIONS.OVYPAY](state, data) {
    if (Array.isArray(data)) {
      state.ovypaycrypto = data;
    } else {
      state.ovypaycrypto = data.networks || [];
    }
  },

  // Stores client_portal_url from general_informations table
  [CRYPTO__MUTATIONS.OVYPAY_CLIENT_URL](state, url) {
    state.ovypayClientUrl = url || '';
  },
};

// Actions
const actions = {
  async [CRYPTO__ACTIONS.SENDOTP]({ commit }) {
    try {
      const url = `${CRYPTO__API.SENDOTP}`;
      const response = await HTTP().get(url);
      if (response.status === 200) {
        commit(CRYPTO__MUTATIONS.CODE, response.data.code);
        return true;
      } else {
        toast.error("Faild to send OTP");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Faild to send OTP");
    }
  },

  async [CRYPTO__ACTIONS.CODEVERIFY]({ commit }, data) {
    try {
      const url = `${CRYPTO__API.CODEVERIFY}`;
      const res = await HTTP().post(url, data);
      if (res.status === 200) {
        toast.success("Crypto Address added successfully.");
        return true;
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Faild to Verify OTP");
    }
  },

  async [CRYPTO__ACTIONS.DELETECRYPTO]({ commit, state }, id) {
    try {
      const url = `${CRYPTO__API.DELETECRYPTO}/${id}`;
      await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(url);
      const updatedCryptos = state.cryptoaddresses.filter(
        (cryptoaddresses) => cryptoaddresses.id !== id
      );
      commit(CRYPTO__MUTATIONS.GETALL, updatedCryptos);
    } catch (error) {
      console.log(error);
    }
  },

  async [CRYPTO__ACTIONS.NETWORKS]({ commit, state }) {
    try {
      const url = `${CRYPTO__API.NETWORKS}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(url);
      commit(CRYPTO__MUTATIONS.NETWORKS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CRYPTO__ACTIONS.GETALL]({ commit, state }) {
    try {
      const url = `${CRYPTO__API.GETALL}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(url);
      commit(CRYPTO__MUTATIONS.GETALL, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CRYPTO__ACTIONS.DETAILS]({ commit, state }, id) {
    try {
      const url = `${CRYPTO__API.DETAILS}/${id}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(url);
      commit(CRYPTO__MUTATIONS.DETAILS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CRYPTO__ACTIONS.CREATE]({ commit, state, dispatch }, data) {
    try {
      const url = `${CRYPTO__API.CREATE}`;
      const res = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(url, data);
      toast.success(res.data.message);
      dispatch(CRYPTO__ACTIONS.GETALL);
      setTimeout(() => {
        router.push("/bank-information?tab=3").catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  },

  // Fetches OvyPay networks + client portal URL in one API call
  // Response shape: { networks: [{name, slug}], client_portal_url: "https://..." }
  async [CRYPTO__ACTIONS.OVYPAY]({ commit }) {
    try {
      const url = `${CRYPTO__API.OVYPAY}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...',
      }).get(url);

      const data = response.data;

      // Commit networks[] → state.ovypaycrypto
      commit(CRYPTO__MUTATIONS.OVYPAY, data);

      // Commit client_portal_url → state.ovypayClientUrl
      if (data && data.client_portal_url) {
        commit(CRYPTO__MUTATIONS.OVYPAY_CLIENT_URL, data.client_portal_url);
      }
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};